var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig } from "@jti/fe-common";
import { Rest } from "../Rest";
const CONTENT_TYPE = "Store";
const DEFAULT_LIMIT = 1000;
export class FlotiqApi extends Rest {
    constructor(baseUrl, apiKey, contentType) {
        var _a;
        if (baseUrl === void 0) { baseUrl = "/"; }
        if (apiKey === void 0) { apiKey = getConfig().FLOTIQ_API_KEY; }
        if (contentType === void 0) { contentType = (_a = getConfig().STORE_LOCATOR_CONTENT_TYPE) !== null && _a !== void 0 ? _a : CONTENT_TYPE; }
        super(baseUrl);
        this.name = "FlotiqApi";
        this.apiKey = apiKey;
        this.contentType = contentType;
        this.setCommonHeader("X-AUTH-TOKEN", this.apiKey);
    }
    static init() {
        return new FlotiqApi(getConfig().FLOTIQ_API_URL);
    }
    getStores(radius, lat, lng, storesLimit = DEFAULT_LIMIT) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams({
                q: "*",
                "geo_filters[Location]": `geo_distance,${radius}m,${lat},${lng}`,
                "content_type[]": this.contentType,
                limit: `${storesLimit}`,
            });
            return yield this.request(`/api/v1/search?${params.toString()}`, {
                method: "GET",
            });
        });
    }
    getStoreByExternalId(externalId) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams({
                q: "*",
                "filters[ExternalId]": externalId,
                "content_type[]": this.contentType,
            });
            return yield this.request(`/api/v1/search?${params.toString()}`, {
                method: "GET",
            });
        });
    }
    getStoreById(storeId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.request(`/api/v1/content/${this.contentType}/${storeId}`, {
                method: "GET",
            });
        });
    }
}
//# sourceMappingURL=FlotiqApi.js.map